import { Theme, css } from '@emotion/react';

export const SITE_MENU_VERTICAL_SPACING_MULTIPLIER = 4;
const SITE_MENU_VERTICAL_SPACING_MULTIPLIER_LOGGED_OUT = 4.5;

export const siteMenuTopLevelHeadingContainer = ({ spacing }: Theme) => css`
  padding-top: ${spacing(SITE_MENU_VERTICAL_SPACING_MULTIPLIER_LOGGED_OUT)}px;
  padding-right: 0;
  padding-bottom: ${spacing(6.5)}px;
  padding-left: 0;
  width: 100%;
`;

export const computeSiteMenuTopLevelHeadingButtonsContainer = ({ spacing }: Theme) => css`
  display: flex;
  justify-content: center;
  margin: 0 ${spacing(2.5)}px;
  & > a {
    flex: 1;
  }
  & > a:first-of-type {
    margin-right: ${spacing(1)}px;
  }
`;

export const siteMenuTopLevelHeadingContainerLoggedIn = ({ breakpoints, spacing }: Theme) => css`
  padding-top: ${spacing(SITE_MENU_VERTICAL_SPACING_MULTIPLIER)}px;
  padding-right: 0;
  padding-bottom: ${spacing(3)}px;
  padding-left: 0;
  ${breakpoints.up('sm')} {
    padding-bottom: ${spacing(4)}px;
  }
`;
